import { on } from "@ngrx/store";
import { SuperUserState } from "../super-user.state";
import { CompaniesActions } from "./companies.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update superUser state within PagesStore
// **************************************************************************

function withSuperUser(state: PagesStore, updater: (superUser: SuperUserState) => SuperUserState): PagesStore {
    return { ...state, superUser: updater(state.superUser) };
}

// **************************************************************************
// COMPANIES REDUCER (array format for PagesStore)
// **************************************************************************

const load = on(CompaniesActions.load, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    companies: { ...superUserState.companies, loading: true, error: null },
})));

const loadSuccess = on(CompaniesActions.loadSuccess, (state: PagesStore, { companies }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    companies: { ...superUserState.companies, companies, loaded: true, loading: false, error: null },
})));

const loadFailure = on(CompaniesActions.loadFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    companies: { ...superUserState.companies, loading: false, error },
})));

const createCompany = on(CompaniesActions.createCompany, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    companies: { ...superUserState.companies, error: null },
})));

const createCompanySuccess = on(CompaniesActions.createCompanySuccess, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    companies: { ...superUserState.companies, error: null },
})));

const createCompanyFailure = on(CompaniesActions.createCompanyFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    companies: { ...superUserState.companies, error },
})));

const updateCompany = on(CompaniesActions.updateCompany, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    companies: { ...superUserState.companies, error: null },
})));

const updateCompanySuccess = on(CompaniesActions.updateCompanySuccess, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    companies: { ...superUserState.companies, error: null },
})));

const updateCompanyFailure = on(CompaniesActions.updateCompanyFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    companies: { ...superUserState.companies, error },
})));

const invalidate = on(CompaniesActions.invalidate, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    companies: { ...superUserState.companies, loaded: false },
})));

export const companiesReducer = [
    invalidate,
    load,
    loadSuccess,
    loadFailure,
    createCompany,
    createCompanySuccess,
    createCompanyFailure,
    updateCompany,
    updateCompanySuccess,
    updateCompanyFailure,
];
